
<div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="add-usuario-perfil-perfilLabel">Add Usuário ao Perfil</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="form" (ngSubmit)="criarUsuario()">

            <div class="row">
                <div class="col-3">
                    <div class="form-group">
                        <label for="nome">Login</label>
                        <input type="text" id="usuario" formControlName="usuario" class="form-control">
                        <div *ngIf="usuarioCtrl.touched  && usuarioCtrl.hasError('required')" class="text-danger">
                            Login é obrigatório.
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <div class="form-group">
                        <label for="nome">Nome Completo</label>
                        <input type="text" id="nome" formControlName="nome" class="form-control">
                        <div *ngIf="nomeCtrl.touched && nomeCtrl.hasError('required')" class="text-danger">
                            Nome é obrigatório.
                        </div>
                    </div>
                </div>
     
                <div class="col-4">
                    <div class="form-group">
                        <label for="email">E-mail</label>
                        <input type="email" id="email" formControlName="email" class="form-control">
                        <div *ngIf="emailCtrl.touched  && emailCtrl.hasError('required')" class="text-danger">
                            Email é obrigatório.
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="row">
                <div class="col-4">
                    <div class="form-group">
                        <label for="dataNascimento">Data de Nascimento</label>
                        <input type="date" id="dataNascimento" formControlName="dataNascimento" class="form-control">
                        <div *ngIf="dataNascimentoCtrl.touched  && dataNascimentoCtrl.hasError('required')"
                            class="text-danger">
                            Data de Nascimento é obrigatória.
                        </div>
                        <div *ngIf="dataNascimentoCtrl.touched  && dataNascimentoCtrl.hasError('adulto')" class="text-danger">
                            Usuário deve ser ter mais de 18 anos.
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="form-group">
                        <label for="ddd">DDD</label>
                        <input type="text" id="ddd" formControlName="ddd" class="form-control">
                        <div *ngIf="dddCtrl.touched  && dddCtrl.hasError('required')" class="text-danger">
                            Número DDD é obrigatório.
                        </div>
                        <div *ngIf="dddCtrl.touched  && dddCtrl.hasError('minlength') || dddCtrl.hasError('maxlength') " class="text-danger">
                            Número DDD deve ter dois digitos.
                        </div>
                        <div *ngIf="dddCtrl.touched  && dddCtrl.hasError('minlength') || dddCtrl.hasError('pattern') " class="text-danger">
                            Somente numeros são permitidos!.
                        </div>
                   
                    </div>
                </div>
                <div class="col-5">
                    <div class="form-group">
                        <label for="tel">Telefone</label>
                        <input type="tel" id="telefone" formControlName="telefone" class="form-control">
                        <div *ngIf="telefoneCtrl.touched  && telefoneCtrl.hasError('required')" class="text-danger">
                            Telefone é obrigatório.
                        </div>
                    </div>
                </div>
                <!-- <div class="col-3">
                    <div class="form-group">
                        <label for="perfilAcesso">Perfil de Acesso</label>
                        <input type="text" id="perfilAcesso" formControlName="perfilAcesso" class="form-control">
                    </div>
                </div> -->
    
                <!-- <div class="col-3">
                    <div class="form-group">
                        <label for="perfilAcesso">Perfil de Acesso</label>
                        <select id="perfilAcesso" formControlName="perfilAcesso" class="form-control">
                            <option *ngFor='let p of perfis'  value="{{p.codperfil}}">{{p.dscperfil}}</option>
                        </select>
                        <div *ngIf="perfilAcessoCtrl.touched  && perfilAcessoCtrl.hasError('required')" class="text-danger">
                            Perfil é obrigatório.
                        </div>
    
                    </div>
                </div> -->
            </div>
    
            <div class="row">
                <!-- <div class="col-4">
                    <div class="form-group">
                        <label for="cpf">CPF</label>
                        <input type="text" id="cpf" formControlName="cpf" class="form-control" placeholder="ex. 00">
                        <div *ngIf="cpfCtrl.touched  && cpfCtrl.hasError('required')" class="text-danger">
                            CPF é obrigatório.
                        </div>
                        <div *ngIf="cpfCtrl.touched  && cpfCtrl.hasError('maxlength')" class="text-danger">
                            CPF de ter no máximo 14 caracteres.
                        </div>
                    </div>
                </div> -->
    
                <div class="col-6">
                    <div class="form-group">
                        <label for="rg">RG</label>
                        <input type="text" id="rg" formControlName="rg" class="form-control" placeholder="ex. 00">
                        <div *ngIf="rgCtrl.touched  && rgCtrl.hasError('required')" class="text-danger">
                            RG é obrigatório.
                        </div>
                        <div *ngIf="rgCtrl.touched  && rgCtrl.hasError('minlength')" class="text-danger">
                            RG de ter no mínimo 9 caracteres.
                        </div>
                    </div>
                </div>
    
                <div class="col-3">
                    <div class="form-group">
                        <label for="orgaoEmissor">Órgão Emissor</label>
                        <input type="text" id="orgaoEmissor" formControlName="orgaoEmissor" class="form-control">
                        <div *ngIf="orgaoEmissorCtrl.touched  && orgaoEmissorCtrl.hasError('required')" class="text-danger">
                            Órgão Emissor é obrigatório.
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="form-group">
                        <label for="dataEmissao">Data de Emissão</label>
                        <input type="date" id="dataEmissao" formControlName="dataEmissao" class="form-control">
                        <div *ngIf="dataEmissaoCtrl.touched  && dataEmissaoCtrl.hasError('required')" class="text-danger">
                            Data de Emissão é obrigatória.
                        </div>
                    </div>
                </div>
            </div>
    
            <!-- <div class="row text-end">
                <div class="col-8 offset-md-4">
                    <button type="submit" class="btn btn-secondary btn-lg" >
                        Criar Usuário
                    </button>
                </div>
            </div> -->
    
    
    
    
            <!-- <div class="form-group">
                        <label for="status">Ativo/Inativo</label>
                        <p class="form-check form-switch">
                            <input class="form-check-input"
                            id="status"
                            formControlName="status"
                            type="checkbox" 
                            checked="true"
                            [disabled]="false"
                           >
                        </p>
                    </div> -->
        </form>

      
     
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-terceary" [disabled]="form.invalid" data-bs-dismiss="modal" (click)="criarUsuario()" >Confirmar Adição de Usuário ao Perfil</button>
      </div>
    </div>
  </div>

